import React, { useCallback, useEffect, useState, useContext } from 'react';
import { HeaderContainer, Buttons, Container, ValidationAlert, BackButton } from '../../style';
import { PageHeader, ButtonWithLoading } from 'scorer-ui-kit';
import { useTranslation } from 'react-i18next';
import { MenuContext, PathContext } from '../../App';
import useLocalStorage from '../../hooks/useLocalstorage';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { saveOperators, savePoseAreas, saveBodyAreas, saveJobs, saveTasks, saveTasksets } from '../../apis';
const ReviewSetup = () => {
  const { t } = useTranslation(['ReviewSetup', 'Common']);
  const [validationAlert/*, setValidationAlert*/] = useState<Alert>({ key: new Date(), message: '', type: 'error' });

  const { completedStep, setCompletedStep, setSelectedStep, setIsEdit } = useContext(MenuContext);
  const { pathUpdated } = useContext(PathContext);
  const { floorPlanStorage } = useLocalStorage();
  const [saveLoading, setSaveLoading] = useState(false);

  /*---------route---------*/
  const onContinue = useCallback((index: number) => {
    if (index === 16) {
      setSelectedStep(index);
      setCompletedStep(completedStep > 17 ? completedStep : 17);
      return;
    }
    setSaveLoading(true);
    setSelectedStep(0);
    setCompletedStep(999);
    setIsEdit(true);

    saveOperators(floorPlanStorage.operators)
      .then((response) => {console.log(response);})
      .catch((error) => {console.error(error);});
    savePoseAreas(floorPlanStorage.PoseAreas)
      .then((response) => {console.log(response);})
      .catch((error) => {console.error(error);});
    saveBodyAreas(floorPlanStorage.BodyAreas)
      .then((response) => {console.log(response);})
      .catch((error) => {console.error(error);});
    saveJobs(floorPlanStorage.jobs)
      .then((response) => {console.log(response);})
      .catch((error) => {console.error(error);});
    saveTasks(floorPlanStorage.tasks)
      .then((response) => {console.log(response);})
      .catch((error) => {console.error(error);});
    saveTasksets(floorPlanStorage.tasksets)
      .then((response) => {console.log(response);})
      .catch((error) => {console.error(error);});
  }, [floorPlanStorage, completedStep, setCompletedStep, setSelectedStep, setIsEdit]);

  useEffect(() => {
    if (pathUpdated) setSelectedStep(17);
  }, [setSelectedStep, pathUpdated]);
  /*---------route---------*/

  return (
    <Container>
      <HeaderContainer>
        <PageHeader title={t('review_setup')} areaHref='/' areaTitle={floorPlanStorage.completed_step === 999 ? '初期設定': '設定編集'} />
        <Buttons>
          <BackButton size='small' design='secondary' onClick={() => onContinue(16)}>{t('Common:back')}</BackButton>
          <ButtonWithLoading loading={saveLoading} design='primary' size='small' onClick={() => onContinue(17)}>
            {t(floorPlanStorage.completed_step === 999 ? 'save' : 'finish_save')}
          </ButtonWithLoading>
        </Buttons>
      </HeaderContainer>

      {validationAlert.message !== '' &&
        <ValidationAlert type={validationAlert.type} message={validationAlert.message} />}

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell>タスクセット名</TableCell>
              <TableCell>関連付けタスク</TableCell>
              <TableCell>関連付けジョブ</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {floorPlanStorage.tasksets.map((taskset: any) => {
              let rowSpanNum = taskset.taskList.length+1;
              for (let i=0; i< taskset.taskList.length; i++) {
                rowSpanNum += taskset.taskList[i].jobList.length;
              }
              return (
                <>
                  <TableRow>
                    <TableCell rowSpan={rowSpanNum}>{taskset.name}</TableCell>
                  </TableRow>
                  {taskset.taskList.map((task: any) => {
                    return (
                      <>
                        <TableRow>
                          <TableCell rowSpan={task.jobList.length+1}>{task.name}</TableCell>
                        </TableRow>
                        {task.jobList.map((job: any) => {
                          return (
                            <TableRow key={job.id}>
                              <TableCell>{job.name}</TableCell>
                            </TableRow>
                          );
                        })}
                      </>
                    );
                  })}
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default ReviewSetup;
